var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('ai-advert-generation-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }